import { memo, useCallback } from 'react';
import { ShouldStartLoadRequest } from 'react-native-webview/lib/WebViewTypes';
import { Config } from '@betty/toolkit/config';
import { useStyle, WebView } from '@betty/moonlight';
import { GameplayProps } from './Gameplay.types';
import useGameplay from '../../hooks/useGameplay';

function Gameplay({
  id,
  deviceType,
  currencyCode,
  onExit,
  onDeposit,
}: GameplayProps) {
  const { url } = useGameplay(id, deviceType, currencyCode);
  const style = useStyle({ backgroundColor: 'screenBackground' });

  const onShouldStartLoadWithRequest = useCallback(
    (request: ShouldStartLoadRequest) => {
      if (
        request.url?.match(`^${Config.PLATFORM_URL}/payment-launch/pre-deposit`)
      ) {
        onDeposit?.();

        return false;
      } else if (request.mainDocumentURL?.match(`^${Config.PLATFORM_URL}`)) {
        onExit?.();

        return false;
      }

      return true;
    },
    [onDeposit, onExit],
  );

  return url ? (
    <WebView
      allowFileAccess
      scrollEnabled
      nestedScrollEnabled
      allowsBackForwardNavigationGestures
      domStorageEnabled
      javaScriptEnabled
      cacheEnabled={!__DEV__}
      webviewDebuggingEnabled={__DEV__}
      originWhitelist={['*']}
      source={{ uri: url }}
      style={style}
      allowsInlineMediaPlayback
      allowsFullscreenVideo={false}
      onShouldStartLoadWithRequest={onShouldStartLoadWithRequest}
    />
  ) : null;
}

export default memo(Gameplay);
